export interface TrayPlacement {
  bedId: string;
  trayCount: number;
  wholeTrayCount?: number;
}

export function resolveSourcePlacement(
  placements: TrayPlacement[] | undefined,
  bedIds: string[],
  physicalQuantity: number,
) {
  const placementKnown = Array.isArray(placements) &&
    (placements.length > 0 || (bedIds.length === 0 && Number.isFinite(physicalQuantity)));
  const greenhouseOnly = placementKnown && placements!.length === 0;
  return {
    placementKnown,
    greenhouseOnly,
    physicalTrays: greenhouseOnly ? Math.ceil(physicalQuantity)
      : (placements ?? []).reduce((sum, bed) => sum + bed.trayCount, 0),
    wholeTrays: greenhouseOnly ? Math.floor(physicalQuantity)
      : (placements ?? []).reduce((sum, bed) => sum + (bed.wholeTrayCount ?? bed.trayCount), 0),
  };
}

export function isTransferQuantityValid(quantity: number, available: number, reserve: number,
  physical: number, wholeTrays = physical): boolean {
  return Number.isSafeInteger(quantity) && quantity > 0 && quantity <= physical &&
    quantity <= Math.min(wholeTrays, Math.floor(Math.max(0, available)) + Math.floor(Math.max(0, reserve)));
}

export function allocateSourceBeds(placements: TrayPlacement[], quantity: number, fullTransfer = false) {
  if (!Number.isSafeInteger(quantity) || quantity <= 0 ||
      placements.some((bed) => !Number.isSafeInteger(bed.trayCount) || bed.trayCount <= 0 ||
        !Number.isSafeInteger(bed.wholeTrayCount ?? bed.trayCount) ||
        (bed.wholeTrayCount ?? bed.trayCount) < 0 ||
        (bed.wholeTrayCount ?? bed.trayCount) > bed.trayCount)) return [];
  let remaining = quantity;
  const allocations = placements.flatMap((bed) => {
    const count = Math.min(remaining, fullTransfer ? bed.trayCount : (bed.wholeTrayCount ?? bed.trayCount));
    remaining -= count;
    return count > 0 ? [{ greenhouseBedId: bed.bedId, trayCount: count }] : [];
  });
  return remaining === 0 ? allocations : [];
}

export function isDestinationAllocationValid(
  allocations: Map<string, number>,
  capacityByBed: Map<string, number>,
  quantity: number,
): boolean {
  // Beds are uncapped: a bed with no entry in capacityByBed has no per-bed maximum.
  return allocations.size > 0 &&
    [...allocations].every(([id, count]) => Number.isSafeInteger(count) && count > 0 &&
      (!capacityByBed.has(id) || count <= capacityByBed.get(id)!)) &&
    [...allocations.values()].reduce((sum, count) => sum + count, 0) === quantity;
}
